import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IUser } from '../model/interfaces'
import { usersApi } from '../api/userApi'

interface IUserState {
  user: IUser
}

const initialState: IUserState = {
  user: {
    _id: '',
    email: '',
    name: '',
    accessLevel: 'usual'
  }
}

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    removeUser(state) {
      state.user = {
        _id: '',
        email: '',
        name: '',
        accessLevel: 'usual'
      }
    },
    setUser(state, { payload }: PayloadAction<IUser>) {
      state.user = payload
    }
  },
  extraReducers: (builder) => {
    builder.addMatcher(usersApi.endpoints.getUser.matchFulfilled, (state, { payload }: PayloadAction<IUser>) => {
      state.user = payload
    })
  }
})

export const userActions = userSlice.actions
export const userReducer = userSlice.reducer
